export enum ResponseHeaders {
  LIST_ITEMS_COUNT_HEADER = 'x-meta-count',
}
